import * as yup from "yup";

export const AddQuizValidation = yup.object().shape({
  tradeId: yup.string().required("Trade is required"),
  bundleId: yup.string().required("Bundle is required"),
  yearId: yup.string().required("Year is required"),
  languageId: yup.string().required("Language is required"),
  subjectId: yup.string().required("Curriculum is required"),
  chapterIds: yup.array(),
  name: yup.string().required("Title is required"),
  isRandom: yup.boolean().required("Time restricted is required"),
  totalQuestions: yup
    .number()
    .typeError("Maximum marks must be a number")
    .optional(),
  marksPerQuestion: yup
    .number()
    .typeError("Maximum attempts must be a number")
    .optional(),
  hasNegativeMarking: yup.boolean().required("Negative marking is required"),
  negativeMark: yup.number().optional(),
  isGraded: yup.boolean().required("Graded is required"),

  maxAttempts: yup
    .number()
    .typeError("Maximum attempts must be a number")
    .optional(),
  passPercentage: yup
    .number()
    .typeError("Maximum attempts must be a number")
    .optional(),

  instructions: yup.string().optional(),
  description: yup.string().optional(),
});

export const schema = yup.object().shape({
  chapters: yup.array().of(
    yup.object().shape({
      easy: yup
        .number()
        .min(0, "Must be at least 0")
        .required("Easy field is required"),
      medium: yup
        .number()
        .min(0, "Must be at least 0")
        .required("Medium field is required"),
      hard: yup
        .number()
        .min(0, "Must be at least 0")
        .required("Hard field is required"),
    })
  ),
});
